export { allowsMandarinPreview } from "./mandarin-preview-access";
export type { MandarinJourneyPaths } from "./publication";
import {
  ENGLISH_JOURNEY_PATHS,
  PREVIEW_MANDARIN_JOURNEY_PATHS,
} from "./publication";
import { PRACTICAL_COURSE } from "../practical-service-facts";
import {
  THEORY_MONTHLY_SESSIONS,
  THEORY_TIER_FEES_SGD,
} from "../theory-pricing";
import {
  LAB_LOCATIONS,
  MAIN_CENTRE,
  toGoogleMapsSearchUrl,
} from "../eclat-locations";

export const PILOT_BASE = PREVIEW_MANDARIN_JOURNEY_PATHS.home;
export const PILOT_PATHS = [
  PREVIEW_MANDARIN_JOURNEY_PATHS.home,
  PREVIEW_MANDARIN_JOURNEY_PATHS.course,
  PREVIEW_MANDARIN_JOURNEY_PATHS.visit,
] as const;
export const PILOT_ENGLISH_PATHS = [
  ENGLISH_JOURNEY_PATHS.home,
  ENGLISH_JOURNEY_PATHS.course,
  ENGLISH_JOURNEY_PATHS.visit,
] as const;

export function getPilotFacts() {
  // Bind to shared records, not a translated copy of addresses or fees.
  const matches = LAB_LOCATIONS.filter(
    (venue) => venue.label === "Henderson Practical Lab"
  );
  if (matches.length !== 1) {
    throw new Error("Pilot Henderson venue requires reconciliation");
  }
  const lab = matches[0];
  return {
    course: PRACTICAL_COURSE,
    theoryMonthlySessions: THEORY_MONTHLY_SESSIONS,
    theoryFees: THEORY_TIER_FEES_SGD,
    labAddress: lab.addressLines,
    labMap:
      lab.gbpShareUrl ?? toGoogleMapsSearchUrl(lab.addressLines),
    centreAddress: MAIN_CENTRE.addressLines,
  };
}
